import { hot } from 'react-hot-loader/root';
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import stopwatch from '../decorators/stopwatch';
class Countdown extends PureComponent {
  static propTypes = {
    seconds: PropTypes.number.isRequired,
    secondsPassed: PropTypes.number.isRequired,
    onFinish: PropTypes.func.isRequired,
    format: PropTypes.func
  };
  UNSAFE_componentWillReceiveProps({
    secondsPassed,
    seconds,
    onFinish
  }) {
    if (secondsPassed > seconds && typeof onFinish === 'function') onFinish();
  }
  renderCountdown() {
    const {
      seconds,
      secondsPassed,
      format
    } = this.props;
    const ds = seconds - secondsPassed;
    if (typeof format === 'function') {
      return format(ds);
    }
    if (ds <= 0) return I18n.t('shared.countdown.m_s', {
      m: 0,
      s: 0
    });
    const h = ds / (60 * 60) % 24 | 0;
    const m = ds / 60 % 60 | 0;
    const s = ds % 60 | 0;
    if (h > 0) return I18n.t('shared.countdown.h_m', {
      h,
      m
    });
    return I18n.t('shared.countdown.m_s', {
      m,
      s
    });
  }
  render() {
    return /*#__PURE__*/React.createElement("span", null, this.renderCountdown());
  }
}
export default hot(stopwatch(Countdown));